import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IMisdeliveryInvestigation } from "../models";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const SaveOrCompleteMSDInvestigation = async (params: IMisdeliveryInvestigation, osdNumber: number, action: "save" | "complete" = "save") => {
  try {
    const response = await axios.post(`${getUrl(ApiType.MSD_IVESTIGATION)}/${osdNumber}/investigation/${action}`, params);
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.saveOrSubmitAPIError, { badRequestOrder: "errorsFirst" });
  }
};
